<i18n>
{
  "en": {
    "tableQr": "TableQr",
    "add": "Add",
    "deleteTitle": "Do you want to delete table qr: \"{0}\" ?",
    "deleteDescription": "This can not be undone",
    "delete": "Delete",
    "createTableQrSuccess": "Created Table Qr \"{0}\" !",
    "createTableQrError": "Error creating Table Qr. Please, try again later.",
    "editTableQrSuccess": "Table Qr \"{0}\" was successfully edited!",
    "editTableQrError": "Error editing Table Qr \"{0}\". Please, try again later.",
    "deleteTableQrSuccess": "Table Qr \"{0}\" was deleted",
    "downloadQrCodeError": "An error occurred while downloading the image"
  },
  "es": {
    "tableQr": "Mesa de qr",
    "add": "Añadir",
    "deleteTitle": "¿Desea borrar la mesa \"{0}\" ?",
    "deleteDescription": "Este cambio es irreversible",
    "delete": "Eliminar",
    "createTableQrSuccess": "Creado la mesa de qr \"{0}\" !",
    "createTableQrError": "Error creando la mesa. Inténtelo de nuevo más tarde.",
    "editTableQrSuccess": "La mesa numero \"{0}\" se editó correctamente",
    "editTableQrError": "Error editando la mesa \"{0}\". Inténtelo de nuevo más tarde.",
    "deleteTableQrSuccess": "La mesa numero \"{0}\" fue borrado",
    "downloadQrCodeError":  "Ha ocurrido un error al descargar la imagen"
  }
}
</i18n>
<template>
  <div>
    <div class="d-flex flex-wrap mx-7 mt-3 mb-3">
      <v-row>
          <v-col cols="12" align-self="center" class="pa-0 my-4">
            <div class="text-center text-h5">
              {{ $t('tableQr') }}
            </div>
          </v-col>
          <v-col align-self="end" class="pa-0 te">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon class="plus-icon mr-0" v-on="on" v-bind="attrs"
                       @click="openModal">
                  <v-icon color="grey" large>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>{{ $t('add') }}</span>
            </v-tooltip>
          </v-col>
      </v-row>
    </div>
    <v-list>
      <div>
        <table-qr-row
          v-for="tableQr in tableQrList"
          :key="tableQr.guid"
          :tableQr="tableQr"
          @edit="() => onEdit(tableQr)"
          @delete="() => onDelete(tableQr)"
          @previewQrCode="onPreviewQrCode"
          @downloadQrCode="onDownloadQrCode"
        >
        </table-qr-row>
      </div>
    </v-list>
    <table-qr-create-edit-modal
      :visible="createModal"
      @confirm="onConfirmCreate"
      @cancel="onCloseModal"
      :tableQr="tableQrToCreate"
      type="create"
    />
    <table-qr-create-edit-modal
      :visible="editModal"
      @confirm="onConfirmEdit"
      @cancel="onCloseModal"
      :tableQr="tableQr"
      type="edit"
    />
    <dynameat-confirmation-modal :visible="deleteModal"
                                 :title="$t('deleteTitle', [userRoleToDeleteTitle])"
                                 :description="$t('deleteDescription')"
                                 :confirm-text="$t('delete')" @confirm="onDeleteTableQr"
                                 @cancel="onCloseModal"/>
    <qr-preview
      :visible="qrPreviewModal"
      @onClose="qrPreviewModal = false"
      :image="selectQrPreview"
    />
  </div>
</template>
<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import { createErrorNotification, createSuccessNotification } from '@ulibs/unnotificationsqueue';
import DynameatConfirmationModal from '@dynameat/components/DynameatConfirmationModal';
import { FileDownloader } from '@core/helpers';
import { TableQr } from '../models';
import TableQrRow from '../components/tableQrRow.vue';
import TableQrCreateEditModal from '../components/tableQrCreateEditModal.vue';
import QrPreview from '../components/qrPreview.vue';
import { Watch } from 'vue-property-decorator'; // <--- Agregado para el watcher

@Component()
@Components({
  TableQrRow,
  DynameatConfirmationModal,
  TableQrCreateEditModal,
  QrPreview
})
@MapActions(['tableQrListRequest', 'menuListRequest', 'deleteTableQr', 'createTableQr', 'editTableQr', 'addNotification', 'linkTreeListRequest'])
@MapGetters(['tableQrList'])
export default class TableQrList extends Vue {
  createModal = false;

  editModal = false;

  deleteModal = false;

  tableQrToCreate = null;

  tableQr = null;

  tableQrToDelete = null;

  qrPreviewModal = false;

  selectQrPreview = null;

  async created() {
    await this.loadData();
  }

  async loadData() {
    await this.tableQrListRequest(this.$route.params.pointOfSaleGuid);
    await this.menuListRequest(this.$route.params.pointOfSaleGuid);
    await this.linkTreeListRequest(this.$route.params.pointOfSaleGuid);
  }


  openModal() {
    this.tableQrToCreate = TableQr.toInstance();
    this.createModal = true;
  }

  onEdit(tableQr) {
    this.tableQr = TableQr.toInstance(tableQr.serialize());
    this.editModal = true;
  }

  onDelete(tableQr) {
    this.tableQrToDelete = TableQr.toInstance(tableQr.serialize());
    this.deleteModal = true;
  }

  onCloseModal() {
    this.createModal = false;
    this.editModal = false;
    this.deleteModal = false;
  }

  onPreviewQrCode(tableQr) {
    this.qrPreviewModal = true;
    this.selectQrPreview = tableQr.qrCode;
  }

  async onDownloadQrCode(tableQr) {
    try {
      await FileDownloader.downloadImageFromUrl(tableQr.qrCode);
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('downloadQrCodeError')));
    }
  }

  async onConfirmCreate(tableQr) {
    try {
      await this.createTableQr(tableQr);
      this.addNotification(createSuccessNotification(this.$t('createTableQrSuccess', [tableQr.number]), null, 3000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('createTableQrError', [tableQr.number])));
    } finally {
      this.onCloseModal();
      this.tableQrToCreate = null;
    }
  }

  async onConfirmEdit(tableQr) {
    try {
      await this.editTableQr(tableQr);
      this.addNotification(createSuccessNotification(this.$t('editTableQrSuccess', [tableQr.number]), null, 3000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('createTableQrError', [tableQr.number])));
    } finally {
      this.onCloseModal();
      this.tableQr = null;
    }
  }

  async onDeleteTableQr() {
    try {
      await this.deleteTableQr(this.tableQrToDelete);
      this.addNotification(createSuccessNotification(this.$t('editTableQrSuccess', [this.tableQrToDelete.number]), null, 3000));
    } catch (e) {
      this.addNotification(createErrorNotification(this.$t('createTableQrError', [this.tableQrToDelete.number])));
    } finally {
      this.onCloseModal();
      this.tableQrToDelete = null;
    }
  }
  @Watch('$route')
  async onRouteChange(to, from) {
    if (to.params.pointOfSaleGuid !== from.params.pointOfSaleGuid) {
      await this.loadData();
    }
  }
}
</script>
